module.exports = __webpack_public_path__ + "packs/media/images/Passend_2-9f24d1c124dd5d509cbcac588f910096.jpg";